<template>
  <div class="blog-container">
    <blog-sign-up-header v-if="!isAuthenticated" class="tw-m-auto tw-max-w-8xl" />
    <header class="section">
      <div class="row">
        <div class="columns small-12">
          <h1>
            {{ title }}
          </h1>
          <p>{{ description }}</p>
        </div>
      </div>
    </header>
    <resources-list :load-more="true" :params="params" :col-count="3" />

    <section class="section row">
      <div class="columns small-12">
        <h3 class="sf-500">More from the blog...</h3>

        <ul class="inline-list">
          <li
            v-for="item in category.items.filter(i => i.slug !== 'uncategorized')"
            :key="item.slug"
          >
            <nuxt-link
              :to="localePath(item.link)"
              :title="'View posts in ' + category.name"
              class="tag-label tag-label-primary"
            >
              {{ item.name }}
            </nuxt-link>
          </li>
        </ul>
      </div>
    </section>

    <resources-list
      v-for="category in page.blogCategories"
      :key="category.url"
      :params="{
        category: category.slug,
        country: $i18n.locale,
        orderBy: 'created',
        perPage: 4,
        types: ['blog'],
      }"
      :col-count="4"
      :title="category.name"
      :subtitle="category.description"
      :link="'/teaching-blog/' + category.slug"
      :class="['category-' + category.slug]"
    />
    <blog-sign-up-header v-if="!isAuthenticated" />
  </div>
</template>

<script>
/* Blog Listing Page
 *
 * @parent:
 * @requests:
 * @events:
 * @props: blogCategories
 * @components: ResourcesList
 * @methods:
 */
import { mapGetters } from 'vuex';

import ResourcesList from '~/components/resource/ResourcesList.vue';
import BlogSignUpHeader from '~/components/BlogSignUpHeader.vue';

export default {
  name: 'BlogIndex',
  components: {
    ResourcesList,
    BlogSignUpHeader,
  },
  async asyncData({ app, store }) {
    const data = { page: null, location: app.i18n.locale };

    try {
      // Load page content from a JSON file - only works with asyncData, not fetch
      const page = await import('@/data/blog_categories.json');

      if (page && page[app.i18n.locale]) {
        data.page = page[app.i18n.locale];
      }
      await store.dispatch('loadCategory', {
        country: app.i18n.locale,
        category: 'category', // Default blog category
      });
    } catch (err) {
      //
    }

    return data;
  },
  data() {
    return {
      title: 'The Chalkboard',
      description:
        'Unlock your teaching potential with the latest teaching ideas, innovative advice for classroom management, wellbeing tips, and much more!',
      params: {
        country: this.$i18n.locale,
        category: 'featured',
        orderBy: 'created',
        perPage: 3,
        types: ['blog'],
      },
    };
  },
  head() {
    return {
      title: this.title + ' Blog',
      meta: [
        { hid: 'title', name: 'title', content: this.title + ' blog' },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  computed: {
    ...mapGetters(['category', 'isAuthenticated']),
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
};
</script>

<style scoped lang="scss">
.icon {
  height: 3rem;
  margin: 0 $base-padding -0.3rem 0;
  padding: 0;
}
@media #{$medium-only} {
  .blog-container {
    padding: 0 3.75rem;
  }
}
@media #{$small-only} {
  .section-resources-list {
    padding: 0 3rem;
  }
  header {
    padding: 2.5rem 3rem 0 3rem;
  }
}
</style>
